import GencoreMark from '../brand/GencoreMark';

/** `/` and unknown paths: there is nothing to pay without a link. */
export default function Home() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-ui-page px-4">
      <div className="w-full max-w-[440px] rounded-card bg-surface p-8 text-center shadow-float">
        <GencoreMark className="mx-auto mb-3 h-10 w-auto" />
        <h1 className="font-display text-xl font-bold">Gencoin checkout</h1>
        <p className="mt-2 text-sm text-ui-mute">Open a payment link from a merchant to pay.</p>
      </div>
    </main>
  );
}
